'use client'

import {
  type common,
  SmokeballClientSdk as SmokeballClientSdkReal
} from '@smokeballdev/smokeball-client-sdk'
import { createAdminDevSdkWrapper } from './admin-dev-sdk'

export { type common }

export const createSbSdkWrapper = (): common.Api => {
  // First try to get the real SDK if it's available
  let realSdk: common.Api | null = null
  
  try {
    // Try to get the real SDK
    realSdk = SmokeballClientSdkReal?.get?.()
    
    if (realSdk) {
      return realSdk
    }
  } catch (error) {
    // Real SDK not available
  }
  
  // Use Admin Dev SDK when real SDK is not available and in local mode or not embedded
  const isInIframe = typeof window !== 'undefined' && window.self !== window.top
  const shouldUseAdminDevSdk = process.env.NODE_ENV === 'development' || !isInIframe
  
  if (shouldUseAdminDevSdk) {
    const reason = process.env.NODE_ENV === 'development' ? 'development mode' : 'web app (not embedded)'
    console.log(`[SDK-WRAPPER] Real SDK not available, using Admin Dev SDK for ${reason}`)
    return createAdminDevSdkWrapper().get()
  }
  
  // In production inside iframe without real SDK, throw an error
  throw new Error('[SDK-WRAPPER] Real Smokeball SDK is not available and Admin Dev SDK is disabled for iframe usage')
} 